export default __webpack_public_path__ + "static/media/options2_2040.fdb6ab06.webp";